const CUSTOMER_SERVICE_URL = 'https://kf.app-lmaxex.top/chat/index?token=7ec81b52e44114148270f0558c355196'

function parseUserInfo(userInfo) {
  if (userInfo && typeof userInfo === 'object') return userInfo

  if (typeof userInfo === 'string' && userInfo) {
    const value = userInfo.trim()
    if (value.startsWith('{')) {
      try {
        return JSON.parse(value)
      } catch (error) {
        return { userName: value }
      }
    }
    return { userName: value }
  }

  const cachedUserInfo = localStorage.getItem('userInfo')
  if (!cachedUserInfo) return {}

  try {
    return JSON.parse(cachedUserInfo)
  } catch (error) {
    return {}
  }
}

export function getCustomerServiceUrl(userInfo) {
  const info = parseUserInfo(userInfo)
  const userName = info.userName || info.username || ''
  const url = new URL(CUSTOMER_SERVICE_URL)

  // 客服系统参数名区分大小写，用户昵称必须使用 nickName。
  if (userName) url.searchParams.set('nickName', userName)
  if (info.uid || info.inviteNumber) url.searchParams.set('uid', info.uid || info.inviteNumber)
  if (info.phone) url.searchParams.set('phone', info.phone)
  if (info.sex !== undefined && info.sex !== null) url.searchParams.set('sex', info.sex)
  if (info.avatar) url.searchParams.set('avatar', info.avatar)
  if (info.openid) url.searchParams.set('openid', info.openid)

  return url.toString()
}

export function openCustomerService(userInfo) {
  window.location.href = getCustomerServiceUrl(userInfo)
}

